/* global Blockly */
import React from 'react';
import util from "../../../utils/es5Utils";

function defineBlock(context) {
    return {
        init: function () {
            let selectTableDropdown = new Blockly.FieldWidgetsDropdown(context, 'tableview');

            this.appendDummyInput('WIDGET')
                .appendField("run edit records")
                .appendField(selectTableDropdown, "ID");

            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Run Edit Records for TableView widget.');
            this.setHelpUrl(`${Blockly.BASE_HELP_URL}#Table`);
        }
    }
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let tableViewId = block.getFieldValue('ID');
            let code = `TableViewModule.saveEdit("${tableViewId}");\n`;
            return code;
        }
    }
}

const RunEditRecords = function (props) {
    const name = 'snap_tableview_run_edit_records';
    RunEditRecords.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return util.widgetsOfType(props.context, "tableview").length ? <block type={name}></block> : null;
}

export default RunEditRecords;